export default class GoStudentSubscriptionInvalid extends Error {
  constructor() {
    super(
      "User is forbidden to access this resource - no valid subscription found."
    );
  }
}
